import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 58740 58741"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:822.391}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="XMLID_307_"
        d="M30096 27411 47649 9886l-13044 6633-4509-13915z"
        className="fil0 stroke-none"
        style={{
          strokeWidth: 822.391,
        }}
      />
      <path
        id="XMLID_512_"
        d="M16510 34586 9856 47619l17595-17567H2590z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_513_"
        d="M48743 10982 31193 28504h24677l-13780-4490z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_514_"
        d="m48715 47650-6634-13044 14055-4554H31143z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_515_"
        d="M2603 28504h24806L9883 10950l6635 13044z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_516_"
        d="M28548 27453V2591l-4535 13920-13033-6655z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_517_"
        d="M49849 49884z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_518_"
        d="M214 29278z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_519_"
        d="M30096 31193v24678l4490-13780 13033 6653z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_520_"
        d="M28548 31145 10949 48716l13044-6633 4555 14054z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
      <path
        id="XMLID_521_"
        d="M8717 49852z"
        className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
